var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconFlexibility(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_3474",
    "data-name": "Group 3474",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 50,
    height: 57.344,
    viewBox: "0 0 50 57.344",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2229",
    "data-name": "Rectangle 2229",
    width: 50,
    height: 57.345,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3473",
    "data-name": "Group 3473",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5606",
    "data-name": "Path 5606",
    d: "M198.672,139.878l6.889,6.9c.535.536,1.068,1.073,1.61,1.6.168.164.266.284.047.5q-4.216,4.209-8.435,8.447a1,1,0,0,1-.11-.662c0-1.683-.021-3.367.012-5.049.01-.527-.156-.562-.612-.473-7.342,1.432-11.034,6.495-12.211,12.846a18.478,18.478,0,0,0-.271,3.452c.011,3.114.016,6.228,0,9.341a2.6,2.6,0,0,1-1.548,2.48,2.714,2.714,0,0,1-3.876-2.39c-.005-3.7-.19-7.419.053-11.106.445-6.767,3.028-12.536,8.7-16.607a20.586,20.586,0,0,1,9.088-3.5c.509-.077.7-.215.68-.771-.046-1.614-.016-3.229-.016-5.016",
    transform: "translate(-157.344 -122.209)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5607",
    "data-name": "Path 5607",
    d: "M133.394,8.532c.721-.7,1.451-1.387,2.162-2.095q3.109-3.093,6.207-6.2c.146-.146.244-.395.53-.108q4.206,4.221,8.43,8.417c-.146.228-.333.128-.481.129-1.577.009-3.156.031-4.732-.007-.554-.013-.733.106-.73.7.026,5.279.009,10.559.027,15.838a1.09,1.09,0,0,1-.47,1,12.169,12.169,0,0,0-2.3,2.232c-.291.371-.425.3-.691-.009A8.995,8.995,0,0,0,140,27.107a1.624,1.624,0,0,1-.655-1.5c.024-5.426.006-10.853.025-16.28,0-.519-.127-.668-.654-.657-1.741.035-3.484.013-5.226.013l-.1-.154",
    transform: "translate(-116.544 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5608",
    "data-name": "Path 5608",
    d: "M8.628,140.208q0,1.152,0,2.3c0,.841.026,1.684-.012,2.523-.02.441.139.559.552.6a25.108,25.108,0,0,1,7.915,1.941,18.163,18.163,0,0,1,6.632,4.9c.194.229.287.4.106.708a18.052,18.052,0,0,0-2.174,5.746,1.664,1.664,0,0,1-.126.283,13.452,13.452,0,0,0-2.228-3.527,14.4,14.4,0,0,0-8.158-4.3c-.678-.137-1.374-.187-2.053-.318-.389-.075-.459.056-.456.413.015,1.766,0,3.533,0,5.3,0,.2,0,.408,0,.783-.337-.33-.568-.552-.794-.778-2.526-2.526-5.043-5.061-7.587-7.57-.346-.341-.319-.494.009-.819q3.858-3.814,7.675-7.67a4.6,4.6,0,0,0,.466-.668l.229.147",
    transform: "translate(0 -122.369)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFlexibility);
export default __webpack_public_path__ + "static/media/icon-flexibility.847b5bcb88c5856b0a6611c9fdf66423.svg";
export { ForwardRef as ReactComponent };